import { customFetch } from '@/lib/utils';

import type { RedeemResponse, ReferralCodeResponse, SendInviteResponse } from './types';

export async function getMyReferralCode({
  accessToken
}: {
  accessToken: string;
}): Promise<ReferralCodeResponse> {
  const res = await customFetch('/backend/signup-referrals/my-code', {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json'
    }
  });
  if (!res.ok) throw await res.json();
  return res.json();
}

export async function redeemReferralCode({
  accessToken,
  code
}: {
  accessToken: string;
  code: string;
}): Promise<RedeemResponse> {
  const res = await customFetch('/backend/signup-referrals/redeem', {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ code })
  });
  if (!res.ok) throw await res.json();
  return res.json();
}

export async function sendSignupReferralInvite({
  accessToken,
  email,
  name
}: {
  accessToken: string;
  email: string;
  name?: string;
}): Promise<SendInviteResponse> {
  const res = await customFetch('/backend/signup-referrals/send-invite', {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ email, name })
  });
  if (!res.ok) throw await res.json();
  return res.json();
}
